import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import FILTER_TYPES from '@/components/query/filter-types';
import SpecResolver from '@/common/spec/spec-resolver';
import _ from '@/common/helpers';


const {
    acquirerName: {enum: gatewayAcquirerNames},
    gatewayName: {enum: gatewayNames},
    method: {enum: gatewayMethods},
    paymentCardSchemes: {enum: gatewayPaymentCardSchemes},
    status: {enum: gatewayStatuses},
} = SpecResolver.resolveEntity('GatewayAccount');

export default {
    id: 'gateway-accounts',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'gatewayAccounts',
                labelBuilder: ({id}) => id,
                value: 'id',
            },
        },
        organizationId: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'organizations',
                labelBuilder: ({id, name}) => `${_.truncate(id, {limit: 11, dots: true})} - ${name}`,
                value: 'id',
            },
        },
        gatewayName: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: gatewayNames.sort(),
            },
        },
        acquirerName: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: gatewayAcquirerNames.sort(),
            },
        },
        status: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: gatewayStatuses.sort(),
            },
        },
        method: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: gatewayMethods.sort(),
            },
        },
        acceptedCurrencies: {
            label: 'Currencies',
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.currencies,
            },
        },
        paymentCardSchemes: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: gatewayPaymentCardSchemes.sort(),
            },
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
        dccMarkup: {
            type: FILTER_TYPES.numeric,
        },
        dynamicDescriptor: {
            type: FILTER_TYPES.boolean,
        },
        threeDSecure: {
            label: '3D Secure',
            type: FILTER_TYPES.boolean,
        },
    },
};
